import React from 'react'

//React Router
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

//Redux hooks and tools
import { Provider } from 'react-redux'
import { store } from './store/store.jsx';

//import the only one global CSS file
import './styles/style.css';

//created components
import Navigator from './steps/navigation/Navigator.jsx'
import ResaSuccess from './pages/resasuccess/ResaSuccess.jsx'
import Success from './pages/order/success/Success.jsx'
import Fail from './pages/order/fail/Fail.jsx'
import ListContrat from './pages/manager/listcontrat/ListContrat.jsx'
import ListUnpaid from './pages/manager/listunpaid/ListUnpaid.jsx'
import RenvoieMail from './pages/manager/renvoiemail/RenvoieMail.jsx'
import Login from './pages/manager/login/Login.jsx'
import Manager from './pages/manager/home/Manager.jsx'
import Contrat from './pages/manager/contrat/Contrat.jsx'
import ManagerJour from './pages/manager/jour/ManagerJour.jsx'
import ManagerSemaine from './pages/manager/semaine/ManagerSemaine.jsx'
import ManagerSearch from './pages/manager/search/ManagerSearch.jsx'
import ManagerCaisse from './pages/manager/caisse/ManagerCaisse.jsx'
import ManagerStocks from './pages/manager/stocks/ManagerStocks.jsx'
import EditContrat from './pages/manager/editcontrat/EditContrat.jsx'
import ModifResa from './pages/manager/modifresa/ModifResa.jsx'



function App() {
  return (
    <React.StrictMode>
      <Provider store={store}> {/* Redux global state provider */}
        <Router>
          <Routes>
            <Route path="/" element={<Navigator /> /* navigator is the main block, managing navigation step by step */} />
            <Route path="/resasuccess/:refContrat/:mail" element={<ResaSuccess />} />
            <Route path="/order/success/:refContrat/:id_contrat" element={<Success />} />
            <Route path="/order/fail/:refContrat" element={<Fail />} />
            <Route path="/manager/listcontrat" element={<ListContrat />} />
            <Route path="/manager/listunpaid" element={<ListUnpaid />} />
            <Route path="/manager/renvoiemail" element={<RenvoieMail />} />
            <Route path="/manager/login/:destination" element={<Login />} />
            <Route path="/manager" element={<Manager />} />
            <Route path="/manager/contrat" element={<Contrat />} />
            <Route path="/manager/jour" element={<ManagerJour />} />
            <Route path="/manager/semaine" element={<ManagerSemaine />} />
            <Route path="/manager/search" element={<ManagerSearch />} />
            <Route path="/manager/caisse" element={<ManagerCaisse />} />
            <Route path="/manager/stocks" element={<ManagerStocks />} />
            <Route path="/manager/editcontrat/:idContrat/:refContrat" element={<EditContrat />} />
            <Route path="/manager/modifresa/:idContrat/:refContrat" element={<ModifResa />} />
          </Routes>
        </Router>
      </Provider>
    </React.StrictMode>

  );
}

export default App;
